<template>
  <div>
    <div>
      <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-3 pb-3 m-0">
        <div class="flex-grow">
          <p class="playfair-display-400 text-base p-0 m-0">List All WFA / WFH / FWA</p> 
        </div>
        <div>
          <export-excel class="roboto-condensed-300 text-xs border rounded cursor-pointer px-2 py-1.5" :data="get_all" :fields="json_fields" worksheet = "My Worksheet" :name="'data-wfa-wfh-fwa-'+tanggal+'.xls'">
            Download Excel
          </export-excel>
        </div>
        <div class="ml-1">
          <el-date-picker v-model="date" type="date" size="mini" style="width: 9rem;" placeholder="Tanggal"></el-date-picker>
        </div>
        <div class="ml-0.5">
          <el-button icon="el-icon-search" size="mini" @click="pencarian" circle></el-button>
        </div>
        <div class="ml-0.5">
          <el-button icon="el-icon-refresh" size="mini" @click="penyegaran" circle></el-button>
        </div>
      </div>
      <div class="flex justify-between items-center border-b border-gray-100 px-5 pt-3 pb-3 m-0">
        <div class="flex-grow">
          <el-select v-model="unit_kerja" size="mini" filterable placeholder="Pilih Unit Kerja" style="width: 100%;">
            <el-option v-for="item in get_unit_kerja" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="ml-0.5">
          <el-input placeholder="Nama" v-model="form.search" size="mini"></el-input>
        </div>
      </div>
    </div>
    <div>
      <!-- Loading skeleton -->
      <div v-if="get_wfh_loading">
        <div v-for="n in 5" :key="n" class="flex justify-between items-center border-b border-gray-100 px-5 pt-2.5 pb-2.5 m-0 animate-pulse">
          <div class="flex-grow">
            <div class="h-3 bg-gray-200 rounded w-32 mb-1"></div>
            <div class="h-4 bg-gray-200 rounded w-48 mb-1"></div>
            <div class="h-3 bg-gray-200 rounded w-40"></div>
          </div>
          <div>
            <div class="h-3 bg-gray-200 rounded w-24"></div>
          </div>
          <div class="ml-2">
            <div class="h-4 w-4 bg-gray-200 rounded-full"></div>
          </div>
        </div>
      </div>
      <!-- Data list -->
      <div v-if="!get_wfh_loading">
        <!-- {{ get_all }} -->
        <div v-for="(item, index) in get_all" :key="index">
          <div class="flex justify-between items-center border-b border-gray-100 hover:bg-gray-50 cursor-pointer px-5 pt-2.5 pb-2.5 m-0">
            <div class="flex-grow">
              <p class="text-gray-600 text-xs text-left roboto-mono-300 p-0 m-0">{{ item.nip | format_nip }}</p>
              <p class="text-base text-left roboto-regular leading-normal cursor-pointer p-0 m-0">{{ item.nickname ? item.nama : item.username }}</p>
              <p class="text-gray-500 text-xs text-left roboto-light p-0 m-0">{{ item.unit_kerja }}</p>
            </div>
            <div>
              <p class="text-xs text-left roboto-light p-0 m-0">{{ item?.tanggal | konversi_tanggal }}</p>
            </div>
            <div class="ml-2">
              <i class="el-icon-error cursor-pointer" @click="open_dialog(item)"></i>
            </div>
          </div>
        </div>
        <div v-if="get_all.length === 0" class="px-5 py-6 text-center text-gray-400 text-sm roboto-light">
          Tidak ada data.
        </div>
      </div>
    </div>
    <el-dialog title="Warning" :visible.sync="dialogvisible" width="30%" center>
      <!-- {{ obj }} -->
      <p class="text-center">Atas nama <span class="font-bold">{{ obj.username}}</span>, yakin akan di hapus?</p>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogvisible = false">Cancel</el-button>
        <el-button type="danger" size="mini" :loading="loading" @click="submit_dialog">Delete</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import ingredient from '@/assets/json/employee.json'
export default {
  data() {
    return {
      employee: ingredient.records,
      date: new Date(),
      unit_kerja: null,
      form: {tanggal: new Date(), unit_kerja: null, input: null, search: null},
      activeFilter: {tanggal: moment(new Date()).format('YYYY-MM-DD'), unit_kerja: null, search: null},
      dialogvisible: false,
      obj: {},
      loading: false,
      json_fields: {
        'NIP': 'nip',
        'Nama': 'nama',
        'Unit Kerja': 'unit_kerja',
        'Tanggal' : 'tanggal'
      },
      json_data: [
        {
          'nip': 'Tony Peña',
          'nama': 'New York',
          'unit_kerja': 'United States',
          'tanggal': '1978-03-15'
        }
      ],
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    }
  },
  filters: {
    konversi_tanggal: function(value){
      moment.locale('id'); 
      return moment(value).format('dddd')+', '+moment(value).format('LL');
    },
    konversi_waktu: function(value){
      moment.locale('id'); 
      return value === null ? 'Belum Absen' : moment(value).format('HH.mm');
    },
    format_nip: function(value) {
      return value.substring(0, 8)+" "+value.substring(8, 14)+" "+value.substring(14, 15)+" "+value.substring(15, 18);
    },
  },
  computed: {
    get_all() {
      let allData = this.$store.state.wfh.all;

      // Filter by tanggal (AND — selalu diterapkan jika ada)
      if (this.activeFilter.tanggal) {
        allData = allData.filter(item => (item.tanggal || '').substring(0, 10) === this.activeFilter.tanggal);
      }

      // Filter by unit_kerja dan nama/username bersifat OR — independen satu sama lain
      const hasUnitKerja = !!this.activeFilter.unit_kerja;
      const hasSearch = !!this.activeFilter.search;

      if (hasUnitKerja || hasSearch) {
        const keyword = hasSearch ? this.activeFilter.search.toLowerCase() : null;
        allData = allData.filter(item => {
          const matchUnitKerja = hasUnitKerja ? item.unit_kerja === this.activeFilter.unit_kerja : false;
          const matchNama = hasSearch
            ? (item.username || '').toLowerCase().includes(keyword) || (item.nama || '').toLowerCase().includes(keyword)
            : false;
          return matchUnitKerja || matchNama;
        });
      }

      return allData;
    },
    get_unit_kerja() {
      return this.$store.state.wfh.unit_kerja
    },
    get_wfh_loading() {
      return this.$store.state.wfh.loading
    },
    tanggal () {
      return moment(this.date).format("YYYY-MM-DD")
    }
  },
  created() {
    this.$store.dispatch('wfh/get_all_jadwal_wfh_or_wfa', {tanggal: moment(this.date).format("YYYY-MM-DD"), unit_kerja: this.form.unit_kerja})
    this.$store.dispatch('wfh/get_unit_kerja')
  },
  methods: {
    pencarian() {
      this.form.tanggal = this.tanggal;
      this.form.unit_kerja = this.unit_kerja;

      // Commit filter aktif baru saat tombol cari diklik
      this.activeFilter.tanggal = this.tanggal;
      this.activeFilter.unit_kerja = this.unit_kerja;
      this.activeFilter.search = this.form.search;

      this.$store.dispatch('wfh/get_all_jadwal_wfh_or_wfa', {tanggal: this.form.tanggal, unit_kerja: this.form.unit_kerja}) 
    },
    penyegaran() {
      this.unit_kerja = null;
      this.form.unit_kerja = null;
      this.form.search = null;

      // Reset filter aktif
      this.activeFilter.tanggal = moment(this.date).format('YYYY-MM-DD');
      this.activeFilter.unit_kerja = null;
      this.activeFilter.search = null;

      this.$store.dispatch('wfh/get_all_jadwal_wfh_or_wfa', { tanggal: moment(this.date).format("YYYY-MM-DD"), unit_kerja: this.form.unit_kerja })
    },
    open_dialog(value) {
      this.obj = value;
      this.dialogvisible = true
    },
    close_dialog() {
      this.dialogvisible = false
    },
    submit_dialog() {
      this.loading = true;
      this.$store.dispatch('wfh/delete_jadwal_wfh_or_wfa', {id: this.obj.id})
      .then(() => {
        this.loading = false;
        this.dialogvisible = false
        this.$store.dispatch('wfh/get_all_jadwal_wfh_or_wfa', {tanggal: this.form.tanggal, unit_kerja: this.form.unit_kerja}) 
      })
      .catch(() => {
        this.loading = false;
      })
    },
    cancel_dialog() {
      this.dialogvisible = false
    },
  }
}
</script>